import { Button, FilterContext, Flex, InputSearch, LocalCashTables, ModalContext, PaginationContext, PaginationPerPageSelect, SearchContext, Select, localStorage } from 'dash-ui';
import { StateFragment, useGetUsStatesQuery } from 'gql/generated.graphql';
import { isEmpty } from 'lodash';
import { MarketAreaModals } from 'pages/market-areas/MarketAreasPage.constants';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const MarketAreasTopBar = () => {
  const { t } = useTranslation(['tables', 'common']);
  const { toggleModal, setPayload } = useContext(ModalContext);
  const { setSearchSlug } = useContext(SearchContext);
  const { state: filterState, setFilterState } = useContext(FilterContext);
  const { state: paginationState, resetPagination } =
    useContext(PaginationContext);
  const [search, setSearch] = useState('');
  const { data: statesData }  = useGetUsStatesQuery({
    variables: {
      filter: {
        withMarketArea: true,
      },
    },
  });

  useEffect(() => {
    const localFilter =
      localStorage.getTableFilter(LocalCashTables.MARKET_AREA) &&
      JSON.parse(localStorage.getTableFilter(LocalCashTables.MARKET_AREA));
    if (localFilter) {
      setFilterState('states', localFilter.states);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(filterState)) {
      localStorage.setTableFilter(LocalCashTables.MARKET_AREA, filterState);
    }
  }, [filterState]);

  const statesOptions = useMemo(() => {
    const states = statesData?.getUSStates || [];
    return states.map(({ name }) => ({
      value: name,
      label: name,
    }));
  }, [statesData]);

  return (
    <Flex w="100%" px={6} py={4} flex={1}>
      <InputSearch
        w="100%"
        css={'height: 40px'}
        placeholder={t('tables:marketAreas.search') || ''}
        value={search}
        onClear={() => {
          setSearch('');
          setSearchSlug('');
          resetPagination();
        }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setSearch(event.target.value);
          setSearchSlug(event.target.value);
          resetPagination();
        }}
      />
      <Select
        ml={4}
        h={40}
        w={200}
        isMulti
        isSearchable={false}
        value={filterState.states}
        onChanged={(_: string, values?: string[]) => {
          setFilterState(
            'states',
            values as StateFragment['name'][]
          );
          if (paginationState.currentPage !== 0) resetPagination();
        }}
        placeholder={t('forms:labels.state')}
        options={statesOptions}
      />
      <PaginationPerPageSelect
        label={`${t('common:labels.show')} `}
        w={130}
        mx={4}
        options={[12, 24, 36, 74]}
      />
      <Button
        icon="plus"
        px={5.5}
        onClick={() => {
          setPayload({ mode: 'add' });
          toggleModal(true, MarketAreaModals.SAVE_MARKET_AREA_MODAL);
        }}
      >
        {t('tables:marketAreas.addNewMarket')}
      </Button>
    </Flex>
  );
};

export default MarketAreasTopBar;
